import { RootState } from "../../store";

export const selectAppIsLoading = (state: RootState) => state.app.isLoading